// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__38JM0","noResults":"styles_noResults__bJQbg","tabs":"styles_tabs__aHaN4","authorItem":"styles_authorItem__1Y4u1","bookItem":"styles_bookItem__1Ru1G"};